import { TierRank } from '@root/entities/tier-rank'
import { TierRankTicker } from '@root/entities/tier-rank/ui/tier-rank-ticker'
import { useOptionalAtom } from '@root/shared/lib'

import type { PremiumMetaModel } from '../../atoms'
import type { ChildrenProps } from '@root/shared/react'

type Props = {
  premiumInfo: PremiumMetaModel | undefined
} & ChildrenProps &
  React.HTMLAttributes<HTMLDivElement>

export const PremiumTicker = ({
  children,
  premiumInfo,
  ...divProps
}: Props) => {
  const premium = useOptionalAtom(premiumInfo?.premium) ?? false
  const tier = useOptionalAtom(premiumInfo?.tier)
  const tierRank = tier ? TierRank.fromPremiumTier(tier) : undefined

  return (
    <TierRankTicker tier={premium ? tierRank : undefined} {...divProps}>
      {children}
    </TierRankTicker>
  )
}
